import React, { useState, useEffect, useRef} from 'react';
import ImageButton from './imageButton';
import AudioRecorder from './AudioRecorder';
// import TestAudioRecorder from './TestAudioRecorder';
// import TestA from './TestA';


const ChatInput = React.memo(({channel, room, uid, username, sendMessage, setSpeaking,
                            server_host, sendVoiceMessage, isVisible }) => {
  const [message, setMessage] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [isResourced, setIsResourced] = useState(false);
  const [isResourcing, setIsResourcing] = useState(false);
  const [audioStream, setAudioStream] = useState(null);
  const [mediaRecorder, setMediaRecorder] = useState()
  const [recognition, setRecognition] = useState()
  const [lastTranscriptTime, setLastTranscriptTime] = useState(Date.now())
  const audioChunks = useState([])
  const [isRipRestit, setIsRipRestit] = useState(false)
  const [isPauseRunning, setIsPauseRunning] = useState(false)
  const [isRipRunning, setIsRipRunning] = useState(false)
  const [isFeedbackRunning, setIsFeedbackRunning] = useState(false)
  const [isFeedbackMaster, setIsFeedbackMaster] = useState(false)
  const [isDirectSend, setIsDirectSend] = useState(false)
  const [ripQuestion, setRipQuestion] = useState('')
  //const audioPlayerRef = useRef(null);
  const testSegmentAudio = useState(null);
  const [audioContext, setAudioContext] = useState(null)
  const [analyser, setAnalyser] = useState(null)
 // const [chuncksQueue, setChuncksQueue] = useState(null)
  const textareaRef = useRef(null);



  
const record_mime = 'audio/webm'
const render_mime = 'audio/webm'
const render_ftyp = '.webm'
const audio_recordtime = 1000

const recorder_options = {
          mimeType: record_mime,
          audioBitsPerSecond: 32000,
          sampleRate: 44100,
          numberOfChannels: 1,
          ignoreMutedMedia: false
        };

        
/* function local_store_audio(audioData, order) {
    

      const blob1 = new Blob([audioData], {type : record_mime})
      const blob = new Blob([blob1], {type : render_mime})
      const audioUrl = URL.createObjectURL(blob)
      const downloadLink = document.createElement('a');
      downloadLink.download = 'audio_fichier_send_' + order.toString() + '_in' + render_ftyp;
      downloadLink.href = audioUrl;
      return new Promise((resolve, reject) => {
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.addEventListener('click', () => {
          // Révoquer l'URL temporaire après le téléchargement
          console.log('locally stored message')
          URL.revokeObjectURL(audioUrl);
          resolve();
        });
        downloadLink.addEventListener('error', () => {
          console.log('Impossible to store message locally')
          reject(new Error('Erreur lors du téléchargement.'));
        });
      document.body.removeChild(downloadLink);
      })
  } */

/* async function send_audio(audioData, stamp) {

      const blob1 = new Blob([audioData], {type : record_mime})
      const blob = new Blob([blob1], { type: 'application/octet-stream' })

      const phoneMsg = {
          'room' : room, 
          'username': username, 
          'stamp' : stamp,
          'audioSegment' : blob
          }  
      channel.emit('phone message', phoneMsg)    
    }*/
 
/* async function play_audio(audioData, order) {
    

      const blob1 = new Blob([audioData], {type : record_mime})
      const blob = new Blob([blob1], {type : render_mime})
      const audioUrl = URL.createObjectURL(blob)
      if (audioPlayerRef.current != null && audioPlayerRef.current.currentTime != 0){
            audioPlayerRef.current.pause();
            audioPlayerRef.current.currentTime = 0;
      }

      const audioPlayer = new Audio();
      audioPlayerRef.current = audioPlayer
      audioPlayerRef.current.type = render_mime;
      audioPlayerRef.current.src = audioUrl;
      try {
        audioPlayerRef.current.addEventListener('ended', () => {
            console.log('La lecture du fichier audio est terminée');
             // Effectuer d'autres actions ici
            URL.revokeObjectURL(audioPlayerRef.current.src)
            });
        audioPlayerRef.current.play()
      } catch (error) {
        console.log('problème de lecture audio ' + error.message)
        audioPlayerRef.current.currentTime = 0
        audioPlayerRef.current.src = null
        audioPlayerRef.current.pause()
        URL.revokeObjectURL(audioUrl)
      }
  } */



  useEffect(
    () => {

 
  // Vérifier la compatibilité du navigateur
     if ((audioStream === null) && ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)
            && navigator.mediaDevices && (!isResourcing)) { // recorders initialization


        setIsResourcing(true)
        navigator.mediaDevices.getUserMedia({   
          audio: true
        })
        .then(stream => {
          setAudioStream(stream, {audio : true})
          const audContext = new  window.AudioContext();
          setAudioContext(audContext)
          const analyserNode = audContext.createAnalyser();
          // Connecter le flux audio du MediaRecorder à l'AnalyserNode
          const sourceNode = audContext.createMediaStreamSource(stream);
          sourceNode.connect(analyserNode);
          setAnalyser(analyserNode)
          const mr = new MediaRecorder(stream, recorder_options)

          let recog;
          if ('SpeechRecognition' in window) {
              recog = new window.SpeechRecognition();
          } else if ('webkitSpeechRecognition' in window) {
              recog = new window.webkitSpeechRecognition();
          } 
          // Configuration de la reconnaissance vocale
          recog.continuous = true;
          recog.lang = 'fr-FR'; // Changez la langue si nécessaire
          recog.interimResults = true;
          recog.audioData = true;
          setMediaRecorder(mr)
          setRecognition(recog)
          setIsResourced(true)
          // initAudioPlayer()
      }).catch( ()=> { // ex : no permission on microphone
      })
     } // end if webkit && mediarecord
    
    }, [isResourcing, audioStream, recorder_options])

function punctuate(text) {
  // Corrige majuscules et ponctuation approximativement
  let t = text.trim();

  // Ajouter un point si ça se termine comme une phrase
  if (/[a-z0-9]$/.test(t)) t += '.';

  // Corriger certaines pauses typiques
  t = t.replace(/\b(et|mais|ensuite|donc|puis|voilà|enfin|bref)\b/gi, '%$1,');
  t = t.replace(/(\s+)(je|tu|il|elle|nous|vous|ils)\b/gi, '% $2');
  t = t.replace(/\s+([?.!])/g, '$1'); // pas d’espace avant ponctuation
  t = t.replace(/^\s*[a-z]/, m => m.toUpperCase()); // majuscule début phrase

  return t;
}    
useEffect(() => {

  if (isResourced) {
            recognition.onresult = (event) => {
             try {
              console.log('Audio event');
              // console.log(' audioChunks size = ' + audioChunks.length)
          
              let interimTranscript = ''
              
              for (let i = event.resultIndex; i < event.results.length; i++) {
                const transcript = event.results[i][0].transcript;

          // Prendre l'audio des dernières 'segmentDuration' secondes
                const transcriptTime = Date.now();
                if (event.results[i].isFinal) {

                   console.log(' ---  final recogntion event --- ');

                  setLastTranscriptTime(transcriptTime)
                  if (isListening){      
                    
                    try {
                      const brutAudioBlob = null // tbd  new Blob(segmentAudio, render_mime)


                      if (isListening) {
                        interimTranscript += transcript
                        if (isDirectSend) {
                          sendVoiceMessage(interimTranscript, [brutAudioBlob])
                        } else {
                          const punctuated = punctuate(interimTranscript)
                          let added_text = ''
                          let prev_text = ''
                          punctuated.split('%').map((p) => {
                            if (p.trim().length > 0) {
                              if (p.trim().length < 30 && added_text.length < 300) {
                                prev_text += p + ' '
                              } else {
                                added_text += ' -- ' + prev_text + p + ' -- ' + '\n'
                                prev_text = ''
                              }
                            }
                          })
                          if (prev_text !== '' ) {
                            added_text += '-- ' + prev_text + ' --\n'
                          }
                          setMessage(message + added_text + '\n')
                          if (textareaRef.current) {
                            textareaRef.current.scrollTop = textareaRef.current.scrollHeight * 1.1;
                          }
                        }
                        interimTranscript = ''
                      }
                      console.log('final transcript ... ' + transcript)
                    } catch (err) {
                      console.log('audio error ' + err.msg)
                    }

                  }


                } else {
                  if (isListening){
                    interimTranscript += transcript
                  }
                  console.log('not final ... ' + transcript)
                }
              } 
             } catch (berr) {
              console.log('unexpected error ' + berr.msg)
             }

            };
          
            recognition.onerror = (event) => {
              console.error('Erreur de reconnaissance vocale:', event.error);
            };
          
          // Redémarrer la reconnaissance vocale après l'arrêt
          recognition.onend = (evt) => {
              console.log('recognition end');
              if (isListening) {
                console.log('recognition restart');
                console.log(' audioChunks size = ' + audioChunks.length)
                const audioTrack = audioStream.getAudioTracks()[0];
                recognition.start(audioTrack)
                // recognition.start(50000);
              }
            };


           }
  }, [isListening, isResourced, recognition, 
      channel, room, username, audioChunks, audioContext, analyser,
        isDirectSend, message, lastTranscriptTime, sendVoiceMessage, testSegmentAudio])


  useEffect( () => {
  
    channel.on('rip status', ripStatus => {
      if (room === ripStatus['room']) {
            setIsRipRestit(ripStatus['restitution'])
            setIsRipRunning((ripStatus['duration'] > 0))
            setRipQuestion(ripStatus['question'])
          }
        })
    channel.on('feedback status', status => {
          if (room === status['room']) {
                setIsFeedbackRunning((status['duration'] > 0))
                setIsFeedbackMaster(status['username'] === username)
              }
    })
    channel.on('pause status', status => {
          if (room === status['room']) {
                    setIsPauseRunning((status['duration'] > 0))
                  }
    })
              
  }, [channel, room, username]);

    
  const handleMicro = (e) => {
    const listen = !isListening
    setIsListening(listen)
    if (listen && mediaRecorder.state === 'inactive') {
      mediaRecorder.start(audio_recordtime)
      const audioTrack = audioStream.getAudioTracks()[0];
      recognition.start(audioTrack)
    }
  };

const handleInputChange = (e) => {
  if (isDirectSend && e.target.value.trim()) { // send each but last sentence chunck
    const tempMessage = e.target.value
    const chuncks = tempMessage.split('\n')
    if (chuncks.length > 1) {
      for (let chunck of chuncks.slice(0, -1)){
        if (chunck.trim()) {
          sendMessage(chunck);
        }
      };
    }
    const remains = chuncks[chuncks.length -1]
    setMessage(remains)
  } else {
      setMessage(e.target.value);
  }
};

const handleSubmit = (e) => {
  if (message.length === 0) {
    toggleDirectSend()
    return
  }

  e.preventDefault();
  if (message.trim()) {
    const chuncks = message.split('\n')
    for (let c of chuncks) {
        if (c.trim()) {
          sendMessage(c);
        }
    }
  // sendMessage(message);
  setMessage('');
  }

};



const setDirectSendOff = () => {
  setIsDirectSend(false)
};

const setDirectSendOn = () => {
  setIsDirectSend(true)
};

const toggleDirectSend = () => {
  setIsDirectSend(!isDirectSend)
};

const clearInput = () => {
  setMessage('')
};

  let placeholder = "Tapez votre message ici..."
  if (isRipRunning) {
    placeholder = "session introspective\n envoyez toutes vos contribution au groupe sur la question : '" + 
                  ripQuestion + "'"
  }
  let sendButtonColor = 'rgb(85, 255, 85)';
  if (isDirectSend) {
    sendButtonColor = '#FF5555'
  }
  // console.log('button color = ' + sendButtonColor)

  let protocol = process.env.REACT_APP_PROTOCOL
  if (protocol === undefined){
    protocol = "http"
  }


  return (
    <div className='chatroom-footer' style={{ display: isVisible ? 'block' : 'none' }}>
    { (! isRipRestit && (! isFeedbackRunning || isFeedbackMaster) && !isPauseRunning) ? (
    <div className='chat-input'>
    
    {isResourced && <AudioRecorder channel={channel} roomId={room} uid={uid} user_name={username}
                      server_host={server_host} isRipRunning={isRipRunning} isFeedbackRunning={isFeedbackRunning}
                      isFeedbackMaster={isFeedbackMaster} isPauseRunning={isPauseRunning} setSpeaking={setSpeaking}/>}
                      

      <textarea className='chat-input-textarea'
        ref={textareaRef}
        value={message}
        onChange={handleInputChange}
        placeholder={placeholder}
        rows={1} // Nombre initial de lignes visibles
      />
      <ImageButton
            url={`${protocol}://${server_host}:3050/images/send.svg`} onClick={handleSubmit} size='small' color={sendButtonColor} 
                title="Rouge si envoi direct (cliquer cet icone), lorsque vert (chaque passage de la souris ou du doigt sur cet icone envoie le message en préparation"/>
      <ImageButton
             url={`${protocol}://${server_host}:3050/images/x-circle.svg`} onClick={clearInput} size='small' title="Effacer le message en cours de rédaction"/>

      {isResourced && isListening ? (
            <ImageButton
              url={`${protocol}://${server_host}:3050/images/type.svg`} onClick={handleMicro} size='small' title="stop speech to text" color='#FF5555'/>
          ) 
          : ( ' ')}
      {isResourced && ! isListening ? (
        <ImageButton
                url={`${protocol}://${server_host}:3050/images/radio.svg`} onClick={handleMicro} color='rgb(85, 255, 85)' size='small' title="démarrer speech to text"/>
  
          ) 
          : ( ' ')}      

            </div>

      ) : (' . . . ')
      }

    </div>
    );

  })

export default ChatInput;